import { render, staticRenderFns } from "./5e_doc.vue?vue&type=template&id=acd8a3b2&scoped=true"
import script from "./5e_doc.vue?vue&type=script&lang=js"
export * from "./5e_doc.vue?vue&type=script&lang=js"
import style0 from "./5e_doc.vue?vue&type=style&index=0&id=acd8a3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd8a3b2",
  null
  
)

export default component.exports